import { css } from 'linaria';

export namespace Styles {
  export const picCover = css`
    position: relative;
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    width: var(--space-1000);
    height: var(--space-1000);
    background-color: var(--background-primary);
  `;

  export const picCoverCntr = css`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: var(--rounding-m);
  `;

  export const picCoverCntrWithErrorOutline = css`
    border: 1px solid var(--attention-primary);
  `;

  export const picCoverImg = css`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `;

  export const picCoverImgVeiled = css`
    opacity: var(--opacity-4);
  `;
}
